<template>
  <div class="w-full xl:w-full flex flex-col space-y-11">
    <div class="relative w-full">
      <FormSelect
        v-model="vacancy"
        :options="vacanciesOptions"
        :invalid="$v.vacancy.$error"
        placeholder="Выбери вакансию*"
        @search-blur="checkData('vacancy')"
      >
        <template #label>
          <div>Выбери вакансию*</div>
        </template>
      </FormSelect>
      <div v-if="$v.vacancy.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
        Выбери вакансию
      </div>
    </div>

    <div class="flex lg:flex-col lg:space-y-11 sm:space-y-9 space-x-4 lg:space-x-0">
      <div class="relative  w-1/2 lg:w-full">
        <FormSelect
          :value="city"
          :options="regionsFormattedOptions"
          :invalid="$v.city.$error"
          searchable
          placeholder="Город*"
          @input="regionsInputHandler"
          @search-blur="checkData('city')"
        >
          <template #label>
            <div>Город*</div>
          </template>
        </FormSelect>
        <div v-if="$v.city.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          Выбери город
        </div>
      </div>
      <div class="relative  w-1/2 lg:w-full">
        <FormSelect
          v-model="shop"
          :options="officesFilteredOptions"
          :invalid="$v.shop.$error"
          :disabled="!city"
          searchable
          placeholder="Магазин*"
          @search-blur="checkData('shop')"
        >
          <template #label>
            <div>Магазин*</div>
          </template>
        </FormSelect>
        <div v-if="$v.shop.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          Выбери магазин
        </div>
      </div>
    </div>
    <div class="flex lg:flex-col lg:space-y-11 sm:space-y-9 space-x-4 lg:space-x-0">
      <div class="relative w-1/2 lg:w-full">
        <FormInput
          v-model="partner"
          placeholder="Партнер*"
          isStatic
        >
          <template #label>
            <div>Партнер*</div>
          </template>
        </FormInput>
      </div>

      <div class="relative w-1/2 lg:w-full">
        <FormSelect
          v-model="schedule"
          :options="schedulesOptions"
          :invalid="$v.schedule.$error"
          placeholder="Желаемый график*"
          @search-blur="checkData('schedule')"
        >
          <template #label>
            <div>Желаемый график*</div>
          </template>
        </FormSelect>
        <div v-if="$v.schedule.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          Выбери график
        </div>
      </div>
    </div>

    <div class="relative w-full">
      <FormInput
        v-model="profit"
        :invalid="$v.profit.$error"
        placeholder="Ожидаемый уровень дохода, ₽*"
        @blur="checkData('profit')"
      >
        <template #label>
          <div>Ожидаемый уровень дохода, ₽*</div>
        </template>
      </FormInput>
      <div v-if="$v.profit.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
        Введи ожидаемый уровень дохода
      </div>
    </div>

    <div class="flex flex-col">
      <FormLabel class="text-left text-neutral-150 mb-4">Занимаешься ли спортом?*</FormLabel>
      <FormRadioGroup
        v-model="goSports"
        :options="radioOptions"
        keyBy="checked"
      />
    </div>
    <div class="flex flex-col">
      <FormLabel class="text-left text-neutral-150 mb-4">Ведёшь ли здоровый образ жизни?*</FormLabel>
      <FormRadioGroup
        v-model="healthyLifestyle"
        :options="radioOptions"
        keyBy="checked"
      />
    </div>
    <FormTextarea
      v-if="goSports"
      v-model="kindsOfSport"
      :invalid="$v.kindsOfSport.$error"
      :placeholder="placeholders.kindsOfSport[inputState.kindsOfSport]"
      @focus="inputFocusHandler('kindsOfSport')"
      @blur="inputBlurHandler('kindsOfSport')"
    />
    <div>
      <FormFile
        v-show="!resume"
        v-model="resume"
        :accept="[
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/pdf',
          'application/vnd.oasis.opendocument.text',
          'application/vnd.oasis.opendocument.spreadsheet',
          'image/jpeg',
          'image/png',
          'image/gif',
        ]"
        @input="fileInputHandler"
      />
      <div
        v-if="!!resume"
        class="flex justify-between"
      >
        <div class="flex space-x-2">
          <img src="@/assets/icons/file.svg" alt="" />
          <span>{{resume[0].name}}</span>
        </div>
        <img
          src="@/assets/icons/cancel.svg"
          alt=""
          class="block cursor-pointer"
          @click="resume = null"
        />
      </div>
    </div>

    <div class="flex space-x-2">
      <FormCheckbox
        v-model="agree"
        :invalid="shouldAgreement"
        @input="($event) => shouldAgreement = !$event"
      />
      <p :class="{ 'text-danger-50': shouldAgreement }">
        Я даю согласие на запись видео во время прохождения онлайн-этапа.
      </p>
    </div>
    <div class="flex sm:flex-col sm:space-y-4 space-x-4 sm:space-x-0">
      <Button palette="neutral-200" @click="goStepBack" class="w-1/2 sm:w-full">Предыдущий шаг</Button>
      <Button @click="submitQuestionInfo" class="w-1/2 sm:w-full">Отправить анкету</Button>
    </div>
    <p class="text-center text-neutral-150 text-sm">
      На почту будет отправлена персональная ссылка для прохождения онлайн этапа.
    </p>
  </div>
</template>
<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import FormInput from '@/components/Form/FormInput.vue';
import FormSelect from '@/components/Form/FormSelect.vue';
import FormRadioGroup from '@/components/Form/FormRadioGroup.vue';
import FormTextarea from '@/components/Form/FormTextarea.vue';
import FormFile from '@/components/Form/FormFile.vue';
import FormCheckbox from '@/components/Form/FormCheckbox.vue';
import FormLabel from '@/components/Form/FormLabel.vue';
import Button from '@/components/UI/Button.vue';
import toast from '@/notify';
import { getVacancy, getCandidateContractor } from '@/api';
import sanitize from '@/sanitize';

export default {
  name: 'VacancyInfo',
  components: {
    FormInput,
    FormSelect,
    FormRadioGroup,
    FormTextarea,
    FormFile,
    FormLabel,
    FormCheckbox,
    Button,
  },
  props: {
    regionsOptions: {
      type: Array,
      default: () => [],
    },
    officesOptions: {
      type: Array,
      default: () => [],
    },
    schedulesOptions: {
      type: Array,
      default: () => [],
    },
    vacanciesOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      vacancy: '',
      city: '',
      cityId: '',
      shop: '',
      schedule: '',
      partner: '',
      profit: '',
      departments: [],
      goSports: true,
      healthyLifestyle: true,
      kindsOfSport: '',
      resume: null,
      agree: false,
      shouldAgreement: false,
      radioOptions: [{ label: 'Да', checked: true }, { label: 'Нет', checked: false }],
      inputState: {
        kindsOfSport: 'blur',
      },
      placeholders: {
        kindsOfSport: {
          focus: 'Например, баскетбол',
          blur: 'Напиши, каким видом спорта ты занимаешься?',
        },
      },
    };
  },
  async mounted() {
    const { position, office } = this.$route.query;
    if (position) {
      const { status, data } = await getVacancy({ position, office });
      if (status === 200) {
        this.vacancy = data.vacancy.name;
        this.shop = data.office.name;
        if (office) {
          const currentOffice = this.officesOptions?.find(({ id }) => id === office);
          const currentRegion = this.regionsFormattedOptions.find(({ ids }) => ids.includes(currentOffice.cityId));
          this.city = currentRegion.key;
        }
      }
    }
    const storageData = JSON.parse(sessionStorage.getItem('vacancyInfo'));
    if (storageData) {
      this.vacancy = storageData.vacancy;
      this.city = storageData.city;
      this.cityId = storageData.cityId;
      this.shop = storageData.shop;
      this.schedule = storageData.schedule;
      this.profit = storageData.profit;
    }
    const storageDataQuestion = JSON.parse(sessionStorage.getItem('questionInfo'));

    if (storageDataQuestion) {
      this.goSports = storageDataQuestion.goSports;
      this.kindsOfSport = storageDataQuestion.kindsOfSport;
      this.resume = storageDataQuestion.resume;
      this.agree = storageDataQuestion.agree;
    }
  },
  validations: {
    vacancy: {
      required,
    },
    city: {
      required,
    },
    schedule: {
      required,
    },
    shop: {
      required,
    },
    profit: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(80),
      symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    },
    kindsOfSport: {
      symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
    },
  },
  computed: {
    vacancyOptions() {
      return ['Грузчик', 'Торговый представитель', 'Системный администратор'];
    },
    regionsFormattedOptions() {
      const cityNames = this.regionsOptions.map(({ name }) => name);
      const uniqCityNames = Array.from(new Set(cityNames));

      return uniqCityNames.map((city) => {
        const ids = this.regionsOptions
          .filter(({ name }) => name === city)
          .map(({ id }) => id);
        return { key: city, label: city, ids };
      });
    },
    officesFilteredOptions() {
      return this.officesOptions
        .filter(({ city }) => (this.city ? city === this.city : true))
        .map(({ name }) => name);
    },
  },
  methods: {
    goStepBack() {
      this.$emit('go-prev');
    },
    checkData(d) {
      this.$v[d].$touch();
    },
    regionsInputHandler(e) {
      this.city = e.label;
      this.departments = e.ids;
      this.shop = '';
    },
    submitQuestionInfo() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        toast.danger({
          text: 'Проверьте окрректность ввода!',
        });
        return;
      }
      if (!this.agree) {
        this.shouldAgreement = true;
        return;
      }
      const formData1 = {
        vacancy: this.vacancy,
        city: this.city,
        cityId: this.shop
          ? sanitize(this.officesOptions.find(({ name }) => name === this.shop).cityId)
          : this.departments[0],
        shop: this.shop,
        schedule: this.schedule,
        profit: sanitize(this.profit),
      };
      this.$emit('vacancy-info-ready', formData1);

      const formData = {
        goSports: this.goSports,
        healthyLifestyle: this.healthyLifestyle,
        kindsOfSport: sanitize(this.kindsOfSport),
        resume: this.resume,
        agree: this.agree,
      };

      this.$emit('question-info-ready', formData);
    },
    inputFocusHandler(d) {
      this.inputState[d] = 'focus';
    },
    inputBlurHandler(d) {
      this.inputState[d] = 'blur';
    },
    fileInputHandler(e) {
      console.log(e);
    },
  },
  watch: {
    async shop(val) {
      try {
        if (val) {
          this.partner = '';

          const officeId = this.officesOptions.find((o) => o.name === val)?.id;

          const {
            data: {
              partnerName,
              ogrn,
              inn,
            },
          } = await getCandidateContractor({ officeId });

          if (partnerName && ogrn && inn) {
            this.partner = `${partnerName}, ОГРН ${ogrn}, ИНН ${inn}`;
          }
        }
      } catch (error) {
        console.log(error);
        //
      }
    },
  },
};
</script>
